import { defineEvent } from '../types/event';
export var COUPON_MODAL_LAUNCH = defineEvent({
    platforms: [
        {
            name: 'Optimizely'
        },
        {
            name: 'Heap',
            alias: 'coupon-modal_impression'
        }
    ]
});
